import fetch from 'cross-fetch';
import { actLoginTimedOut } from 'actions/loginStateActions';
import { actUploadFilesRecord } from 'actions/fileAction';
import { ApiV1Base, ApiPrefix, json, statusCheck, getCookie } from '../util/icwUtility';

// INIT Functions

export const PRODUCT_MANAGER_INIT = 'PRODUCT_MANAGER_INIT';
export function actProductManagerInit() {
  return { type: PRODUCT_MANAGER_INIT };
}

// GET PRODUCT PROFILE

export const PRODUCT_MANAGER_GET_PRODUCT_PROFILE_BEGIN =
  'PRODUCT_MANAGER_GET_PRODUCT_PROFILE_BEGIN';
function actProductManagerGetProductProfileBegin() {
  return { type: PRODUCT_MANAGER_GET_PRODUCT_PROFILE_BEGIN };
}

export const PRODUCT_MANAGER_GET_PRODUCT_PROFILE_SUCCESS =
  'PRODUCT_MANAGER_GET_PRODUCT_PROFILE_SUCCESS';
export function actProductManagerGetProductProfileSuccess(data) {
  return { type: PRODUCT_MANAGER_GET_PRODUCT_PROFILE_SUCCESS, data };
}

export const PRODUCT_MANAGER_GET_PRODUCT_PROFILE_FAIL = 'PRODUCT_MANAGER_GET_PRODUCT_PROFILE_FAIL';
function actProductManagerGetProductProfileFail(reason) {
  return { type: PRODUCT_MANAGER_GET_PRODUCT_PROFILE_FAIL, reason };
}

export function actProductManagerGetProductProfile(productId) {
  return (dispatch) => {
    dispatch(actProductManagerGetProductProfileBegin());
    return fetch(`${ApiV1Base}${ApiPrefix}/product/${productId}`, {
      headers: { Authorization: getCookie('token') },
    })
      .then(statusCheck)
      .then(json)
      .then((data) => dispatch(actProductManagerGetProductProfileSuccess(data)))
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }

        dispatch(
          actProductManagerGetProductProfileFail(typeof err === 'object' ? err.message : err)
        );
      });
  };
}

// PUT PRODUCT PROFILE

export const PRODUCT_MANAGER_PUT_PRODUCT_BEGIN = 'PRODUCT_MANAGER_PUT_PRODUCT_BEGIN';
function actProductManagerPutProductBegin() {
  return { type: PRODUCT_MANAGER_PUT_PRODUCT_BEGIN };
}

export const PRODUCT_MANAGER_PUT_PRODUCT_SUCCESS = 'PRODUCT_MANAGER_PUT_PRODUCT_SUCCESS';
export function actProductManagerPutProductSuccess(data) {
  return { type: PRODUCT_MANAGER_PUT_PRODUCT_SUCCESS, data };
}

export const PRODUCT_MANAGER_PUT_PRODUCT_FAIL = 'PRODUCT_MANAGER_PUT_PRODUCT_FAIL';
function actProductManagerPutProductFail(reason) {
  return { type: PRODUCT_MANAGER_PUT_PRODUCT_FAIL, reason };
}

export const actProductManagerPutProduct = (filesDz, formData, companyId, deleteData) => (
  dispatch
) => {
  dispatch(actProductManagerPutProductBegin());

  const { files, path } = filesDz;

  actUploadFilesRecord(files, path).then(async (productThumbnail) => {
    const response = await fetch(`${ApiV1Base}${ApiPrefix}/product/${formData.id}`, {
      method: 'PUT',
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        formData,
        productThumbnail,
        companyId,
        deleteData,
      }),
    })
      .then(statusCheck)
      .then(json)
      .then((data) => data)
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }

        dispatch(actProductManagerPutProductFail(typeof err === 'object' ? err.message : err));
      });

    const product = await fetch(`${ApiV1Base}${ApiPrefix}/product/${response.id}`, {
      headers: { Authorization: getCookie('token') },
    })
      .then(statusCheck)
      .then(json)
      .then((data) => data)
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }

        dispatch(
          actProductManagerGetProductProfileFail(typeof err === 'object' ? err.message : err)
        );
      });

    if (product) {
      dispatch(actProductManagerPutProductSuccess(product));
    }
  });
};

// POST FOLDER CREATE

export const PRODUCT_MANAGER_POST_FOLDER_BEGIN = 'PRODUCT_MANAGER_POST_FOLDER_BEGIN';
function actProductManagerPostFolderBegin() {
  return { type: PRODUCT_MANAGER_POST_FOLDER_BEGIN };
}

export const PRODUCT_MANAGER_POST_FOLDER_SUCCESS = 'PRODUCT_MANAGER_POST_FOLDER_SUCCESS';
export function actProductManagerPostFolderSuccess(data) {
  return { type: PRODUCT_MANAGER_POST_FOLDER_SUCCESS, data };
}

export const PRODUCT_MANAGER_POST_FOLDER_FAIL = 'PRODUCT_MANAGER_POST_FOLDER_FAIL';
function actProductManagerPostFolderFail(reason) {
  return { type: PRODUCT_MANAGER_POST_FOLDER_FAIL, reason };
}

export function actProductManagerPostFolder(productId, parentId, type, name) {
  return (dispatch) => {
    dispatch(actProductManagerPostFolderBegin());
    return fetch(`${ApiV1Base}${ApiPrefix}/product/folder`, {
      method: 'POST',
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        productId,
        parentId,
        type,
        name,
      }),
    })
      .then(statusCheck)
      .then(json)
      .then((data) => {
        if (data.success) {
          dispatch(actProductManagerPostFolderSuccess(data[type]));
        }
      })
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }

        dispatch(actProductManagerPostFolderFail(typeof err === 'object' ? err.message : err));
      });
  };
}

// UPDATE TAB FOLDER
export const PRODUCT_MANAGER_UPDATE_FOLDER_BEGIN = 'PRODUCT_MANAGER_UPDATE_FOLDER_BEGIN';
function actProductManagerUpdateFolderBegin() {
  return { type: PRODUCT_MANAGER_UPDATE_FOLDER_BEGIN };
}
export const PRODUCT_MANAGER_UPDATE_FOLDER_FAIL = 'PRODUCT_MANAGER_UPDATE_FOLDER_FAIL';
function actProductManagerUpdateFolderFail(reason) {
  return { type: PRODUCT_MANAGER_UPDATE_FOLDER_FAIL, reason };
}

export function actProductManagerUpdateFolder(productId, oldName, newName) {
  return (dispatch) => {
    dispatch(actProductManagerUpdateFolderBegin());

    return fetch(`${ApiV1Base}${ApiPrefix}/product/tab`, {
      method: 'PUT',
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        productId,
        oldName,
        newName,
      }),
    })
      .then(statusCheck)
      .then(json)
      .then((data) => {
        if (data.success) dispatch(actProductManagerGetProductProfile(productId));
      })
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }

        dispatch(actProductManagerGetProductProfile(productId));
        dispatch(actProductManagerUpdateFolderFail(typeof err === 'object' ? err.message : err));
      });
  };
}

// DELETE TAB FOLDER
export const PRODUCT_MANAGER_DELETE_FOLDER_BEGIN = 'PRODUCT_MANAGER_DELETE_FOLDER_BEGIN';
function actProductManagerDeleteFolderBegin(reason) {
  return { type: PRODUCT_MANAGER_DELETE_FOLDER_BEGIN, reason };
}
export const PRODUCT_MANAGER_DELETE_FOLDER_FAIL = 'PRODUCT_MANAGER_DELETE_FOLDER_FAIL';
function actProductManagerDeleteFolderFail() {
  return { type: PRODUCT_MANAGER_DELETE_FOLDER_FAIL };
}

export function actProductManagerDeleteFolder(productId, name) {
  return (dispatch) => {
    dispatch(actProductManagerDeleteFolderBegin());

    return fetch(`${ApiV1Base}${ApiPrefix}/product/tab`, {
      method: 'DELETE',
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        productId,
        name,
      }),
    })
      .then(statusCheck)
      .then(json)
      .then((data) => {
        if (data.success) dispatch(actProductManagerGetProductProfile(productId));
      })
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }

        dispatch(actProductManagerDeleteFolderFail(typeof err === 'object' ? err.message : err));
      });
  };
}

// CREATE FILES

export const PRODUCT_MANAGER_CREATE_FILES_BEGIN = 'PRODUCT_MANAGER_CREATE_FILES_BEGIN';
function actProductManagerCreateFilesBegin() {
  return { type: PRODUCT_MANAGER_CREATE_FILES_BEGIN };
}

export const PRODUCT_MANAGER_CREATE_FILES_SUCCESS = 'PRODUCT_MANAGER_CREATE_FILES_SUCCESS';
export function actProductManagerCreateFilesSuccess(data) {
  return { type: PRODUCT_MANAGER_CREATE_FILES_SUCCESS, data };
}

export const PRODUCT_MANAGER_CREATE_FILES_FAIL = 'PRODUCT_MANAGER_CREATE_FILES_FAIL';
function actProductManagerCreateFilesFail(reason) {
  return { type: PRODUCT_MANAGER_CREATE_FILES_FAIL, reason };
}

export function actProductManagerCreateFiles(files, path, parentId, productId, type) {
  return (dispatch) => {
    dispatch(actProductManagerCreateFilesBegin());

    return actUploadFilesRecord(files, path).then((fileContents) => {
      fetch(`${ApiV1Base}${ApiPrefix}/product/files`, {
        method: 'POST',
        headers: {
          Authorization: getCookie('token'),
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          fileContents,
          parentId,
          productId,
          type,
        }),
      })
        .then(statusCheck)
        .then(json)
        .then((data) => {
          if (data) {
            dispatch(
              actProductManagerCreateFilesSuccess({
                [type]: data.fileArr,
              })
            );
          }
        })
        .catch((err) => {
          if (err.status === 401) {
            dispatch(actLoginTimedOut());
          }

          dispatch(actProductManagerCreateFilesFail(typeof err === 'object' ? err.message : err));
        });
    });
  };
}

// UPDATE FILES

export const PRODUCT_MANAGER_UPDATE_FILES_BEGIN = 'PRODUCT_MANAGER_UPDATE_FILES_BEGIN';
function actProductManagerUpdateFilesBegin() {
  return { type: PRODUCT_MANAGER_UPDATE_FILES_BEGIN };
}

export const PRODUCT_MANAGER_UPDATE_FILES_SUCCESS = 'PRODUCT_MANAGER_UPDATE_FILES_SUCCESS';
export function actProductManagerUpdateFilesSuccess(data) {
  return { type: PRODUCT_MANAGER_UPDATE_FILES_SUCCESS, data };
}

export const PRODUCT_MANAGER_UPDATE_FILES_FAIL = 'PRODUCT_MANAGER_UPDATE_FILES_FAIL';
function actProductManagerUpdateFilesFail(reason) {
  return { type: PRODUCT_MANAGER_UPDATE_FILES_FAIL, reason };
}

export function actProductManagerUpdateFiles(key, value, id) {
  return (dispatch) => {
    dispatch(actProductManagerUpdateFilesBegin());

    fetch(`${ApiV1Base}${ApiPrefix}/product/files`, {
      method: 'PUT',
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        key,
        value,
        id,
      }),
    })
      .then(statusCheck)
      .then(json)
      .then((data) => {
        dispatch(actProductManagerUpdateFilesSuccess({ id, key, data: data.result }));
      })
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }

        dispatch(actProductManagerUpdateFilesFail(typeof err === 'object' ? err.message : err));
      });
  };
}

// CREATE REMINDER FOR DOCUNMENT

export const PRODUCT_MANAGER_CREATE_REMINDER_BEGIN = 'PRODUCT_MANAGER_CREATE_REMINDER_BEGIN';
function actProductManagerCreateReminderBegin() {
  return { type: PRODUCT_MANAGER_CREATE_REMINDER_BEGIN };
}

export const PRODUCT_MANAGER_CREATE_REMINDER_SUCCESS = 'PRODUCT_MANAGER_CREATE_REMINDER_SUCCESS';
export function actProductManagerCreateReminderSuccess(data) {
  return { type: PRODUCT_MANAGER_CREATE_REMINDER_SUCCESS, data };
}

export const PRODUCT_MANAGER_CREATE_REMINDER_FAIL = 'PRODUCT_MANAGER_CREATE_REMINDER_FAIL';
function actProductManagerCreateReminderFail(reason) {
  return { type: PRODUCT_MANAGER_CREATE_REMINDER_FAIL, reason };
}

export function actProductManagerCreateReminder(id, value) {
  return (dispatch) => {
    dispatch(actProductManagerCreateReminderBegin());

    fetch(`${ApiV1Base}${ApiPrefix}/product/reminder`, {
      method: 'POST',
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id,
        value,
      }),
    })
      .then(statusCheck)
      .then(json)
      .then((data) => {
        dispatch(actProductManagerCreateReminderSuccess({ id, data: data.result }));
      })
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }

        dispatch(actProductManagerCreateReminderFail(typeof err === 'object' ? err.message : err));
      });
  };
}

// GET ALL REMINDERS FOR PRODUCT

export const PRODUCT_MANAGER_GET_REMINDER_BEGIN = 'PRODUCT_MANAGER_GET_REMINDER_BEGIN';
function actProductManagerGetReminderBegin() {
  return { type: PRODUCT_MANAGER_GET_REMINDER_BEGIN };
}

export const PRODUCT_MANAGER_GET_REMINDER_SUCCESS = 'PRODUCT_MANAGER_GET_REMINDER_SUCCESS';
export function actProductManagerGetReminderSuccess(data) {
  return { type: PRODUCT_MANAGER_GET_REMINDER_SUCCESS, data };
}

export const PRODUCT_MANAGER_GET_REMINDER_FAIL = 'PRODUCT_MANAGER_GET_REMINDER_FAIL';
function actProductManagerGetReminderFail(reason) {
  return { type: PRODUCT_MANAGER_GET_REMINDER_FAIL, reason };
}

export function actProductManagerGetReminder(productId) {
  return (dispatch) => {
    dispatch(actProductManagerGetReminderBegin());

    fetch(`${ApiV1Base}${ApiPrefix}/product/${productId}/reminders/`, {
      method: 'GET',
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then(statusCheck)
      .then(json)
      .then((data) => {
        dispatch(actProductManagerGetReminderSuccess(data));
      })
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }

        dispatch(actProductManagerGetReminderFail(typeof err === 'object' ? err.message : err));
      });
  };
}

// UPDATE REMINDER

export const PRODUCT_MANAGER_UPDATE_REMINDER_BEGIN = 'PRODUCT_MANAGER_UPDATE_REMINDER_BEGIN';
function actProductManagerUpdateReminderBegin() {
  return { type: PRODUCT_MANAGER_UPDATE_REMINDER_BEGIN };
}

export const PRODUCT_MANAGER_UPDATE_REMINDER_SUCCESS = 'PRODUCT_MANAGER_UPDATE_REMINDER_SUCCESS';
export function actProductManagerUpdateReminderSuccess(data) {
  return { type: PRODUCT_MANAGER_UPDATE_REMINDER_SUCCESS, data };
}

export const PRODUCT_MANAGER_UPDATE_REMINDER_FAIL = 'PRODUCT_MANAGER_UPDATE_REMINDER_FAIL';
function actProductManagerUpdateReminderFail(reason) {
  return { type: PRODUCT_MANAGER_UPDATE_REMINDER_FAIL, reason };
}

export function actProductManagerUpdateReminder(id, updateObj) {
  return async (dispatch) => {
    dispatch(actProductManagerUpdateReminderBegin());

    const updateResult = await fetch(`${ApiV1Base}${ApiPrefix}/product/${id}/reminder/${updateObj.id}`, {
      method: 'PUT',
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(updateObj),
    })
      .then(statusCheck)
      .then(json)
      .then((data) => data)
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }

        dispatch(actProductManagerUpdateReminderFail(typeof err === 'object' ? err.message : err));
      });

    const reminders = await fetch(`${ApiV1Base}${ApiPrefix}/product/${id}/reminders`, {
      method: 'GET',
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then(statusCheck)
      .then(json)
      .then((data) => data)
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }

        dispatch(actProductManagerGetReminderFail(typeof err === 'object' ? err.message : err));
      });

    if (updateResult.success && reminders.success) {
      dispatch(actProductManagerUpdateReminderSuccess(reminders));
    }
  };
}

// DELETE REMINDER

export const PRODUCT_MANAGER_DELETE_REMINDER_BEGIN = 'PRODUCT_MANAGER_DELETE_REMINDER_BEGIN';
function actProductManagerDeleteReminderBegin() {
  return { type: PRODUCT_MANAGER_DELETE_REMINDER_BEGIN };
}

export const PRODUCT_MANAGER_DELETE_REMINDER_SUCCESS = 'PRODUCT_MANAGER_DELETE_REMINDER_SUCCESS';
export function actProductManagerDeleteReminderSuccess(data) {
  return { type: PRODUCT_MANAGER_DELETE_REMINDER_SUCCESS, data };
}

export const PRODUCT_MANAGER_DELETE_REMINDER_FAIL = 'PRODUCT_MANAGER_DELETE_REMINDER_FAIL';
function actProductManagerDeleteReminderFail(reason) {
  return { type: PRODUCT_MANAGER_DELETE_REMINDER_FAIL, reason };
}

export function actProductManagerDeleteReminder(id, reminderId) {
  return async (dispatch) => {
    dispatch(actProductManagerDeleteReminderBegin());

    const deleteObj = await fetch(`${ApiV1Base}${ApiPrefix}/product/${id}/reminder/${reminderId}`, {
      method: 'DELETE',
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then(statusCheck)
      .then(json)
      .then((data) => data)
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }

        dispatch(actProductManagerDeleteReminderFail(typeof err === 'object' ? err.message : err));
      });

    const reminders = await fetch(`${ApiV1Base}${ApiPrefix}/product/${id}/reminders`, {
      method: 'GET',
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then(statusCheck)
      .then(json)
      .then((data) => data)
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }

        dispatch(actProductManagerGetReminderFail(typeof err === 'object' ? err.message : err));
      });

    if (deleteObj.success && reminders.success) {
      dispatch(actProductManagerDeleteReminderSuccess(reminders));
    }
  };
}
// SEND SHRAE FILES EMAIL

export const PRODUCT_MANAGER_SEND_SHARE_FILES_EMAIL_BEGIN =
  'PRODUCT_MANAGER_SEND_SHARE_FILES_EMAIL_BEGIN';
function actProductManagerSendShareFilesEamilBegin() {
  return { type: PRODUCT_MANAGER_SEND_SHARE_FILES_EMAIL_BEGIN };
}

export const PRODUCT_MANAGER_SEND_SHARE_FILES_EMAIL_SUCCESS =
  'PRODUCT_MANAGER_SEND_SHARE_FILES_EMAIL_SUCCESS';
export function actProductManagerSendShareFilesEamilSuccess(data) {
  return { type: PRODUCT_MANAGER_SEND_SHARE_FILES_EMAIL_SUCCESS, data };
}

export const PRODUCT_MANAGER_SEND_SHARE_FILES_EMAIL_FAIL =
  'PRODUCT_MANAGER_SEND_SHARE_FILES_EMAIL_FAIL';
function actProductManagerSendShareFilesEamilFail(reason) {
  return { type: PRODUCT_MANAGER_SEND_SHARE_FILES_EMAIL_FAIL, reason };
}

export function actProductManagerSendShareFilesEamil(value, path, companyId) {
  return (dispatch) => {
    dispatch(actProductManagerSendShareFilesEamilBegin());

    fetch(`${ApiV1Base}${ApiPrefix}/product/shareFiles/email`, {
      method: 'POST',
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        value,
        path,
        companyId,
      }),
    })
      .then(statusCheck)
      .then(json)
      .then((data) => {
        dispatch(actProductManagerSendShareFilesEamilSuccess());
      })
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }

        dispatch(
          actProductManagerSendShareFilesEamilFail(typeof err === 'object' ? err.message : err)
        );
      });
  };
}
